/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ExceptionData
 */
export interface ExceptionData {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof ExceptionData
     */
    $type?: ExceptionDataTypeEnum;
}


/**
 * @export
 */
export const ExceptionDataTypeEnum = {
    SystemCollectionsIDictionarySystemPrivateCoreLib: 'System.Collections.IDictionary, System.Private.CoreLib'
} as const;
export type ExceptionDataTypeEnum = typeof ExceptionDataTypeEnum[keyof typeof ExceptionDataTypeEnum];



/**
 * Check if a given object implements the ExceptionData interface.
 */
export function instanceOfExceptionData(value?: unknown): value is ExceptionData {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ExceptionDataTypeEnum)[0];
}

export function ExceptionDataFromJSON(json: any): ExceptionData {
    return ExceptionDataFromJSONTyped(json, false);
}

export function ExceptionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExceptionData {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ExceptionDataToJSON(value?: ExceptionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
            ...value,
        '$type': value['$type'],
    });
}

